import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const AgentHubIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    "data-icon-name": "AgentHub",
    viewBox: "0 0 32 32",
    focusable: "false",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.991 16.167c0 .377-.148.735-.42.998L17.156 29.58c-.28.28-.639.42-.997.42-.36 0-.718-.14-.998-.42L2.413 16.85a1.42 1.42 0 0 1 0-2.004L14.83 2.413a1.42 1.42 0 0 1 2.003 0l3.098 3.098c.297-.088.612-.14.944-.14 1.75 0 3.159 1.417 3.159 3.158s-1.417 3.159-3.159 3.159-3.158-1.418-3.158-3.159q0-.55.184-1.05l-2.074-2.065L5.414 15.826 16.167 26.58 26.58 16.167l-.464-.463a1.42 1.42 0 0 1 0-2.004 1.42 1.42 0 0 1 2.004 0l1.461 1.461c.271.271.42.63.42 1.006z"
    })
  }));
};
AgentHubIcon.displayName = 'AgentHubIcon';